module.exports = __webpack_public_path__ + "static/media/adelaide_crows.4a1e172.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/adelaide_crows.mp3
// module id = HXLe
// module chunks = 0